import React, { forwardRef } from 'react';
import { clsx } from 'clsx';
import { nativeSelectClassName, fieldLabelClassName } from './formControlClasses';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  options: SelectOption[];
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  label,
  error,
  helperText,
  options,
  className,
  id,
  ...props
}, ref) => {
  const inputId = id || `select-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="w-full min-w-0">
      {label && (
        <label
          htmlFor={inputId}
          className={clsx('block mb-1', fieldLabelClassName)}
        >
          {label}
        </label>
      )}
      <select
        id={inputId}
        ref={ref}
        className={clsx(
          'block w-full max-w-full min-w-0 px-4 py-2',
          nativeSelectClassName,
          error
            ? 'border-error-500 focus:ring-error-500'
            : undefined,
          className
        )}
        {...props}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="mt-1 text-sm text-error-600 dark:text-error-400">{error}</p>
      )}
      {helperText && !error && (
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{helperText}</p>
      )}
    </div>
  );
});

Select.displayName = 'Select';

